<template>
  <svg width="22"
       height="16"
       viewBox="0 0 22 16"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M3.48535 15.2832H18.5059C20.4131 15.2832 21.3975 14.29 21.3975 12.4092V2.91699C21.3975 1.03613 20.4131 0.0517578 18.5059 0.0517578H3.48535C1.58691 0.0517578 0.59375 1.03613 0.59375 2.91699V12.4092C0.59375 14.2988 1.58691 15.2832 3.48535 15.2832ZM2.34277 3.0752C2.34277 2.23145 2.79102 1.80957 3.59961 1.80957H18.3916C19.2002 1.80957 19.6484 2.23145 19.6484 3.0752V3.70801H2.34277V3.0752ZM3.59961 13.5254C2.79102 13.5254 2.34277 13.1035 2.34277 12.2598V5.77344H19.6484V12.2598C19.6484 13.1035 19.2002 13.5254 18.3916 13.5254H3.59961ZM4.79492 11.9346H6.94824C7.4668 11.9346 7.81836 11.5918 7.81836 11.0996V9.46484C7.81836 8.97266 7.4668 8.62988 6.94824 8.62988H4.79492C4.28516 8.62988 3.93359 8.97266 3.93359 9.46484V11.0996C3.93359 11.5918 4.28516 11.9346 4.79492 11.9346Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'CashIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
